let driftIsLoaded = chatIsOpen = false

const onChatScriptLoad = () => {
	window.drift.on('ready', () => {
		driftIsLoaded = true;
		window.drift.hide();
		window.drift.on('chatClose', function () {
			window.drift.hide();
			chatIsOpen = false;
		});
		window.drift.on('message', function () {
			window.drift.show();
		});
	});
};

const driftScript = () => {
	if ( driftIsLoaded ) return false

	!function(){var t=window.driftt=window.drift=window.driftt||[];if(!t.init){if(t.invoked)return void(window.console&&console.error&&console.error("Drift snippet included twice."));t.invoked=!0,t.methods=["identify","config","track","reset","debug","show","ping","page","hide","off","on"],t.factory=function(e){return function(){var n=Array.prototype.slice.call(arguments);return n.unshift(e),t.push(n),t}},t.methods.forEach(function(e){t[e]=t.factory(e)}),t.load=function(t){var e=3e5*Math.ceil(new Date/3e5),n=document.createElement("script");n.type="text/javascript",n.async=!0,n.crossorigin="anonymous",n.src="https://js.driftt.com/include/"+e+"/"+t+".js";var o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(n,o)}}}(),drift.SNIPPET_VERSION="0.3.1",drift.load("ztwt7nuteu3d"), onChatScriptLoad();

	driftIsLoaded = true
	return true
}

const onConnectClick = (element) => {
	if ( ! element && ! window.drift) return

	element.addEventListener('click', (e) => {
		e.preventDefault()

		if (chatIsOpen) {
			window.drift.api.hideChat();
			chatIsOpen = false;
		} else {
			window.drift.api.openChat();
			setTimeout(() => {
				window.drift.show();
			}, 200);
			chatIsOpen = true;
		}
	})

};

document.addEventListener("scroll", driftScript, {once: true});
document.addEventListener('DOMContentLoaded', () => {

	let trigger = document.getElementById('chat-trigger')
	if (!trigger) return

	onConnectClick(trigger)
	
})
